import { DmDoctorFormFields } from './DmDoctorFormFields';
import { DmInlineError } from './DmInlineError';
import { DmModalBody } from './DmModalBody';
import { DmModalFooter } from './DmModalFooter';
import { DmPracticesPicker } from './DmPracticesPicker';
import type { DmDoctorStep } from './useDmDoctorStep';

interface DmNewDoctorStepProps {
    practiceId: string;
    step: DmDoctorStep;
    isSaving: boolean;
    onCreatePractice: () => void;
    onCancel: () => void;
}

export function DmNewDoctorStep({
    practiceId,
    step,
    isSaving,
    onCreatePractice,
    onCancel
}: DmNewDoctorStepProps) {
    const created = step.created;
    return (
        <>
            <DmModalBody>
                <h3 className="text-[13px] font-bold text-gray-800">New DM doctor</h3>
                {created ? (
                    <p className="text-[13px] text-gray-600">
                        {created.fullName} (#{created.doctorId}) was created in DM. Save to link
                        them.
                    </p>
                ) : (
                    <DmDoctorFormFields
                        form={step.form}
                        onChange={step.setForm}
                        errors={step.errors}
                    />
                )}
                <DmPracticesPicker
                    practiceId={practiceId}
                    practices={step.practices}
                    onChange={step.setPractices}
                    onCreateNew={onCreatePractice}
                    readOnly={created !== null}
                />
                {step.submitError && <DmInlineError message={step.submitError} />}
            </DmModalBody>
            <DmModalFooter
                onCancel={onCancel}
                primaryLabel={created ? 'Save' : 'Create doctor and save'}
                pendingLabel={step.isCreating ? 'Creating…' : 'Saving…'}
                onPrimary={step.submit}
                isPending={step.isCreating || isSaving}
                primaryDisabled={step.practices.length === 0}
            />
        </>
    );
}
